<template>
<div class="license-form-response-holder">
     <div class="license-form-response-container">
      <img
        class="response-close-button"
        width="24"
        height="24"
        v-on:click="closeResponse()"
        :src="require('@/assets/icons/closeicon.svg')"
      />
    <div class="license-form-response">
      <img
        width="64"
        height="64"
        :src="require('@/assets/icons/successicon.svg')"
      />
      <div class="license-form-response-title">Request has been submited</div>
      <div class="license-form-response-description">
        Thank you for submitting your request for a license subscription. We
        will be contacting you shortly.
      </div>
    </div>
  </div>
</div>

</template>

<script>
export default {
  methods: {
    closeResponse() {
      this.$emit('closeResponse')
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/licenseFormResponse.scss"
</style>
